module.exports = __webpack_public_path__ + "static/media/mask.42423eb6.svg";